SlideView = require "views/slide"
{ DraggyView }    = require "views/components/draggy"
Preloader = require "lib/preload"
Device    = require "lib/device"

class ComparisonView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"
    "fittextend": "onFitTextEnd"

  show: ->
    @createDraggy()
    @slideToStart()

    @trigger("resize")

  getStartPosition: ->
    @options.data.startPosition?.split?(" ")[0].toLowerCase() or "middle"

  slideToStart: ->
    offset =
      switch @getStartPosition()
        when "before" then 1
        when "after"  then 0
        else 0.5

    window.setTimeout =>
      @draggy?.reset x: @draggy.offset.width * offset
    , 1

  beforeShow: ->
    images = @findAll("img")
    @setEl @findOne(".slider-wrapper"), "slider-wrapper"
    @setEl @findOne(".slider"), "slider"
    @setEl @findOne(".slider-knob"), "knob"
    @setEl @findAll(".slider-item"), "items"
    @setEl @findOne(".slider-title"), "title"
    @setEl @findOne(".slider-labels"), "labels"

    @draggy?.undelegateEvents()
    @draggy = null
    delete @draggy

    if images.length > 0
      Preloader.load _.pluck(images, "src"), => @sizeContent()
    else
      @sizeContent()

    if @options.name is 0
      window.setTimeout =>
        @fitText()
        @show()
      , 400

  refresh: (params) ->
    position =
      if not _.isEqual(params.data.before, @options.data.before)
        0.75
      else if not _.isEqual(params.data.after, @options.data.after)
        0.25

    super

    @beforeShow()

    if position
      @createDraggy()
      @draggy.reset { x: @draggy.offset.width * position }
      @onDrag(@draggy, false, 1, true)
    else
      @show()

  onRefresh: ->
    # don't call @show

  onFitTextEnd: ->
    @sizeContent(true)

  createDraggy: ->
    if @draggy
      @draggy.undelegateEvents()

    width = @getEl("slider").offsetWidth

    @draggy = new DraggyView
      el: @getEl("slider")
      minX: 0
      maxX: width
      lock: "y"
      isParent: true

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop

  onDrag: (draggy, shouldTransit, scale = 1.1, isInitialDrag = false) ->
    transition = if shouldTransit then "all 300ms" else ""

    @transform @getEl("knob"),
      x: Math.round draggy.x
      scale: scale
      transition: transition

    x = Math.round Math.max Math.min(draggy.x, draggy.offset.width), 0

    if not @draggy or draggy.x is draggy.offset.width / 2
      @setState false, "side"
    else
      side = if x > draggy.offset.width / 2 then "before" else "after"
      @setState side, "side"
      @transform @getEl("slider-wrapper"), y: 0, transition: "500ms"
      @transform @getEl("title"),  y: 0, transition: "500ms"
      
    if not isInitialDrag  
      @setState("touched")
    else
      sliderLabels = @getEl("labels")
      sliderLabels.classList.add("initialized")

    for el, i in @getEl("items")
      s = if i is 0 then draggy.offset.width + .5 else -.5
      @transform el, { x: x - s, transition }
      @transform el.firstChild, { x: s - x, transition }

  onDrop: (draggy, isReset) ->
    if isReset
      @onDrag(draggy, true, 1, true)
    else
      @onDrag(draggy, true, 1, false)

  sizeContent: () ->
    @setState false, "sized"

    els    = @findAll(".multi-content-wrapper, .multi-content-text")
    labels = @findOne(".slider-labels")

    @getEl("slider").style.height = ""
    @getEl("slider").style.width  = ""

    fs = parseFloat window.getComputedStyle(@getEl("slider")).fontSize

    height = _.reduce labels.children, (m, el) ->
      Math.max(m, el.offsetHeight)
    , 0

    labels.style.height = "#{height / fs}em"

    size = _.reduce els, (m, el) ->
      h: Math.max(m.h, el.offsetHeight)
      w: Math.max(m.w, el.offsetWidth)
    , { h: 80, w: 0}

    @getEl("slider").style.height = "#{size.h / fs}em"
    @getEl("slider").style.width  = "#{size.w / fs}em"

    @setState true, "sized"

    yOffset = (height + fs * 1.2) / 2
    @transform(@getEl("slider-wrapper"), y: yOffset)
    @transform(@getEl("title"), y: yOffset) unless Device.breakpoint(["md","lg"])

    if @draggy
      @draggy.options.maxX = size.w
      @draggy.getOffset()
      @onDrag(@draggy, false, 1, true)
    else
      start =
        switch @getStartPosition()
          when "before" then 0
          when "after" then 1
          else 0.5

      @onDrag { x: size.w * start, offset: { width: size.w } }, false, 1, true


module.exports = ComparisonView
